module.exports = __webpack_public_path__ + "abe745323392dea13b21c2dfff845936.woff2";